import React from 'react'
import Placeholder, { IPlaceholderProps } from '..'

import styles from './index.module.css'

interface IPlaceholderTextProps extends IPlaceholderProps {
  lines?: number
  lineHeight?: string
}

export function Text(props: IPlaceholderTextProps) {
  const { lines = 1, lineHeight = '1em', ...rest } = props

  return (
    <div>
      {Array.from({ length: lines }, (_, index) => {
        const isLastLine = index === lines - 1
        const isOddLine = index % 2 !== 0
        // eslint-disable-next-line no-nested-ternary
        const lineWidth = isLastLine && index > 0 ? '60%' : isOddLine ? '95%' : '99%'

        return (
          <Placeholder
            className={styles.textLine}
            key={index}
            width={lineWidth}
            height={lineHeight}
            rounded
            {...rest}
          />
        )
      })}
    </div>
  )
}

Text.displayName = 'Placeholder.Text'
